import $ from 'jquery';
import Swal from 'sweetalert2';

export default function () {

    // login formu
    $('.js-login-form').on('submit', function (e) {
        e.preventDefault();

        if (!$(this).valid())
            return;

        var formData = $(this).serialize();

        if (formData) {
            $.ajax({
                url: window.GLOBALS.baseLink + 'giris-yap',
                type: 'POST',
                data: formData,
                dataType: 'json',
                success: function (response) {
                    if (response) {
                        if (response.IsSuccess) {
                            Swal.fire(response.Title, response.Message, response.Class);
                            if (response.Redirect) {
                                setTimeout(function () {
                                    window.location.href = response.Redirect;
                                }, 1000)
                            }
                        } else {
                            Swal.fire(response.Title, response.Message, response.Class);
                        }
                    }
                }
            })
        }
    });

    register();
    forgotPassword();
    saveForgotPassword();
    gotoTab();    
}

function register() {
    $('.js-register-form').on('submit', function (e) {
        e.preventDefault();

        if (!$(this).valid())
            return;

        const formData = new FormData($(this)[0]);

        $.ajax({
            url: window.GLOBALS.baseLink + 'kayit',
            type: 'POST',
            data: formData,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {
                if (response) {
                    if (response.IsSuccess) {
                        Swal.fire(response.Title, response.Message, response.Class);
                        if (response.Redirect) {
                            setTimeout(function () {
                                window.location.href = response.Redirect;
                            }, 1000)
                        }
                    } else {
                        Swal.fire(response.Title, response.Message, response.Class);
                    }
                }
            }
        })
    })
}

function forgotPassword() {
    $('.js-fp-form').on('submit', function (e) {
        e.preventDefault();

        if (!$(this).valid())
            return;

        const formData = new FormData($(this)[0]);
        const $that = $(this);
        window.waitMe($(this));

        $.ajax({
            url: window.GLOBALS.baseLink + 'sifre-sifirla',
            type: 'POST',
            data: formData,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {
                if (response) {
                    if (response.IsSuccess) {
                        Swal.fire(response.Title, response.Message, response.Class, );
                        if (response.Redirect) {
                            setTimeout(function () {
                                window.location.href = response.Redirect;
                            }, 1000)
                        }
                        window.closeWaitMe($that);
                    } else {
                        Swal.fire(response.Title, response.Message, response.Class);
                        window.closeWaitMe($that);
                    }
                }
            }
        })


    })
}

function saveForgotPassword() {
    $('.js-fp-update-form').on('submit', function (e) {
        e.preventDefault();

        if (!$(this).valid())
            return;

        const formData = new FormData($(this)[0]);
        const $that = $(this);
        window.waitMe($(this));

        $.ajax({
            url: window.GLOBALS.baseLink + 'sifre-kaydet',
            type: 'POST',
            data: formData,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {
                if (response) {
                    if (response.IsSuccess) {
                        Swal.fire(response.Title, response.Message, response.Class, );
                        if (response.Redirect) {
                            setTimeout(function () {
                                window.location.href = response.Redirect;
                            }, 1000)
                        }
                        window.closeWaitMe($that);
                    } else {
                        Swal.fire(response.Title, response.Message, response.Class);
                        window.closeWaitMe($that);
                    }
                }
            }
        })
    })
}

function gotoTab() 
{
    setTimeout(() => {
        if(window.location && window.location.hash)
        {
            $('.ps-form--account .ps-tab-list li').removeClass('active');
            $(`.ps-form--account .ps-tab-list li > a[href='${window.location.hash}']`).parent().addClass('active');
            // Tab icerigini degistir
            $('.ps-form--account .ps-tabs .ps-tab').removeClass('active');
            $(`.ps-form--account .ps-tabs .ps-tab${window.location.hash}`).addClass('active');
        }
    }, 500)
}